import React from "react";
import { Button } from "../../../components/ui";
import { Loader2, Plus } from "lucide-react";
import ProductRow from "./ProductRow";

export default function ProductsSection({
  loadingProducts,
  products,
  availableProducts,
  updateProduct,
  setProducts,
  addProductRow,
  totalAll,
  shouldShowError,
  fieldErrors
}) {
  return (
    <div className="products">
      <div className="subtitle">Products</div>
      {loadingProducts ? (
        <div className="flex items-center justify-center py-4">
          <Loader2 className="h-4 w-4 animate-spin mr-2" />
          Loading products...
        </div>
      ) : (
        products.map((p, idx) => (
          <ProductRow
            key={idx}
            product={p}
            idx={idx}
            availableProducts={availableProducts}
            updateProduct={updateProduct}
            removeProduct={() => setProducts(ps => ps.filter((_, i) => i !== idx))}
          />
        ))
      )}

      <Button variant="outline" onClick={addProductRow} className="mt-3">
        <Plus className="h-4 w-4 mr-2" />
        Add product
      </Button>
      <div className="total mt-3 text-lg font-semibold">Grand Total: ₹{totalAll}</div>
      {shouldShowError('products') && <div className="text-sm text-red-600 mt-2">{fieldErrors.products}</div>}
    </div>
  );
}

